<template>
    <div class="electronicTicket-box">
        <HeaderNav
            header-title="电子运单"
            left-icon-name="2"
            right-icon-name="3"
        ></HeaderNav>
        <div class="container">
            <div class="code-con">
                <div class="info-con">
                    <div class="item">
                        <div class="icon-con">
                            <span class="iconfont iconbianhao"></span>
                        </div>
                        <label>运输单编号:</label>
                        <span> {{ formData.pcb_number }}</span>
                    </div>
                    <div class="item">
                        <div class="icon-con">
                            <span class="iconfont iconshijian"></span>
                        </div>
                        <label>发货时间:</label>
                        <span>
                            {{ formData.pcsj }}
                        </span>
                    </div>
                </div>
                <div class="qrCode-con">
                    <img :src="qrCodeUrl">
                </div>
            </div>
            <div class="project-list">
                <div class="project-item">
                    <ul>
                        <li>
                            <span class="icon icon1"></span>
                            <span class="info">工程名称：</span>
                            <span class="info-value">{{ formData.project_name }}</span>
                        </li>
                        <li>
                            <span class="icon icon2"></span>
                            <span class="info">工程地址：</span>
                            <span class="info-value">{{ formData.project_address }}</span>
                        </li>
                        <li>
                            <span class="icon icon3"></span>
                            <span class="info">发货场站：</span>
                            <span class="info-value">{{ formData.station_name }}</span>
                        </li>
                        <li>
                            <span class="icon icon4"></span>
                            <span class="info">合同编号：</span>
                            <span class="info-value">{{ formData.contract_number }}</span>
                        </li>
                        <li>
                            <span class="icon icon4"></span>
                            <span class="info">任务编号：</span>
                            <span class="info-value">{{ formData.task_number }}</span>
                        </li>
                        <li>
                            <span class="icon icon5"></span>
                            <span class="info">生产日期：</span>
                            <span class="info-value">{{ formData.pcsj }}</span>
                        </li>
                        <li>
                            <span class="icon icon6"></span>
                            <span class="info">浇筑方式：</span>
                            <span class="info-value">{{ formData.pouring_name }}</span>
                        </li>
                        <li>
                            <span class="icon icon2"></span>
                            <span class="info">施工部位：</span>
                            <span class="info-value">{{ formData.place_name }}</span>
                        </li>
                        <li>
                            <span class="icon icon6"></span>
                            <span class="info">强度等级：</span>
                            <span class="info-value">{{ formData.strength_grade_name }}</span>
                        </li>
                        <li>
                            <span class="icon icon7"></span>
                            <span class="info">塌落度：</span>
                            <span class="info-value">{{ formData.slump }}±{{ formData.slump_name }}</span>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="project-list project-list-col2">
                <div class="project-item">
                    <van-row>
                        <van-col span="12">
                            <span class="icon icon8"></span>
                            <span class="info">车牌号：</span>
                            <span class="info-value">{{ formData.plate_number }}</span>
                        </van-col>
                        <van-col span="12">
                            <span class="icon icon9"></span>
                            <span class="info">车号：</span>
                            <span class="info-value">{{ formData.plate_small_number }}</span>
                        </van-col>
                    </van-row>
                    <van-row>
                        <van-col span="12">
                            <span class="icon icon10"></span>
                            <span class="info">车次：</span>
                            <span class="info-value">{{ formData.ljcs }}</span>
                        </van-col>
                        <van-col span="12">
                            <span class="icon icon11"></span>
                            <span class="info">运距：</span>
                            <span class="info-value">{{ formData.haul_distance }}km</span>
                        </van-col>
                    </van-row>
                    <van-row>
                        <span class="icon icon5"></span>
                        <span class="info">出站时间：</span>
                        <span class="info-value">{{ formData.out_time }}</span>
                    </van-row>
                    <van-row>
                        <span class="icon icon5"></span>
                        <span class="info">到场时间：</span>
                        <span class="info-value">{{ formData.arrival_time }}</span>
                    </van-row>
                    <van-row>
                        <span class="icon icon5"></span>
                        <span class="info">始卸时间：</span>
                        <span class="info-value">{{ formData.unload_time }}</span>
                    </van-row>
                    <van-row span="12">
                        <span class="icon icon5"></span>
                        <span class="info">卸毕时间：</span>
                        <span class="info-value">{{ formData.unload_over_time }}</span>
                    </van-row>
                </div>
            </div>
            <div class="sign-con">
                <div class="sign-name">
                    <label>签收人：</label>
                    <input readonly v-model="formData.signUser">
                </div>
                <p class="tip">
                    说明：未经过本公司许可不得往混凝土内添加水或其他材料，否则由此引起的
                    质量问题概不负责！
                </p>
            </div>
        </div>
    </div>
</template>

<script>
import { HeaderNav } from '@/components/';
import { Toast } from 'vant';
export default {
    components: {
        HeaderNav,
    },
    props: {},
    data() {
        return {
            pcb_number: '',
            formData: {},
            qrCodeUrl: '',
        };
    },
    watch: {},
    computed: {},
    methods: {
        // 获取电子运单详情
        getElecPcb() {
            this.$axios
                .get('/interfaceApi/production/productpcb/get_elec_pcb?pcb_number=' + this.pcb_number)
                .then(res => {
                    if (res) {
                        this.formData = res;
                    }
                })
                .catch(error => {
                    this.$toast(error.ErrorCode.Message);
                });
        },
    },
    created() {
        this.pcb_number = this.$route.params.pcb_number;
        this.getElecPcb();
        this.qrCodeUrl = '/interfaceApi/auth/get_qrcode/' + this.pcb_number + '/5';
    },
    mounted() {},
};
</script>
<style lang="stylus" scoped>
.electronicTicket-box
    padding-top 44rpx
    height calc(100% - 44rpx)
    .container
        height 100%
        overflow-y auto
        overflow-x hidden
        .code-con
            height 115rpx
            padding 10rpx 0 10rpx 10rpx
            .info-con
                width calc(100% - 90rpx)
                float left
                .item
                    border-bottom 1px dashed #D7D7D7
                    font-size 14rpx
                    padding 10rpx 0
                    &:last-child
                        border-bottom 0
                    .icon-con
                        display inline-block
                        vertical-align middle
                        .iconfont
                            font-size 16rpx
                            color #979EA7
                    label
                        color #979EA7
            .qrCode-con
                width 90rpx
                height 100%
                position relative
                float left
                img
                    position absolute
                    top -2rpx
                    left -2rpx
                    width 90rpx
                    height 90rpx
        .project-list
            background #F0F0F0
            padding 12rpx
            .project-item
                padding 12rpx
                background #fff
                .icon
                    width 18rpx
                    height 18rpx
                    display inline-block
                    vertical-align middle
                    margin-right 8rpx
                    &:before
                        content ' '
                        width 16rpx
                        height 16rpx
                        display inline-block
                        background-repeat no-repeat
                        background-size 100% 100%
                    &.icon1
                        &:before
                            background-image url(./../../../assets/images/icons/icon_2.png)
                    &.icon2
                        &:before
                            background-image url(./../../../assets/images/icons/icon_gy_2.png)
                    &.icon3
                        &:before
                            background-image url(./../../../assets/images/icons/icon_gy_8.png)
                    &.icon4
                        &:before
                            background-image url(./../../../assets/images/icons/icon_gy_1.png)
                    &.icon5
                        &:before
                            background-image url(./../../../assets/images/icons/icon_gy_7.png)
                    &.icon6
                        &:before
                            background-image url(./../../../assets/images/icons/icon_gy_3.png)
                    &.icon7
                        &:before
                            background-image url(./../../../assets/images/icons/icon_16.png)

                    &.icon8
                        &:before
                            background-image url(./../../../assets/images/icons/icon_gy_9.png)
                    &.icon9
                        &:before
                            background-image url(./../../../assets/images/icons/icon_18.png)
                    &.icon10
                        &:before
                            background-image url(./../../../assets/images/icons/icon_19.png)
                    &.icon11
                        &:before
                            background-image url(./../../../assets/images/icons/icon_11.png)
                .info
                    color #666666
                    font-size 14rpx
                .info-value
                    color #979EA7
                    font-size 14rpx
                    width calc(100% - 96rpx)
                li
                    margin-bottom 10rpx
                    overflow hidden
                    line-height 22rpx
                .van-row
                    margin-bottom 10rpx
                    line-height 22rpx
        .project-list-col2
            padding-top 0
        .sign-con
            padding 15rpx
            .sign-name
                text-align right
                input
                    border none
                    border-bottom 1px solid #D7D7D7
                    padding 5rpx
                    border-radius 0
            .tip
                margin-top 10rpx
                color #E60000
                font-size 10rpx
                line-height 22rpx
</style>